
import { Subscription } from '@/api/tripply/models'
import { defineComponent, computed, PropType } from 'vue'
import { store } from '@/store'

export default defineComponent({
  name: 'SubscriptionPlan',
  emits: ['subscribe', 'unsubscribe', 'reactivate'],
  props: {
    name: String,
    planId: String,
    price: Number,
    subscription: {
      type: Object as PropType<Subscription>,
      required: true
    },
    features: Array,
    getButton: String
  },
  setup(props) {
    
    const current = computed(() => props.subscription.planId == props.planId)
    const expiring = computed(() => current.value && props.subscription.expiring)
    
    return { store, expiring, current }
  }
})
